"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluralAttribute = exports.CollectionType = void 0;
var tslib_1 = require("tslib");
var Attribute_1 = require("./Attribute");
var CollectionType;
(function (CollectionType) {
    CollectionType[CollectionType["COLLECTION"] = 0] = "COLLECTION";
    CollectionType[CollectionType["LIST"] = 1] = "LIST";
    CollectionType[CollectionType["MAP"] = 2] = "MAP";
    CollectionType[CollectionType["SET"] = 3] = "SET";
})(CollectionType = exports.CollectionType || (exports.CollectionType = {}));
var PluralAttribute = /** @class */ (function (_super) {
    tslib_1.__extends(PluralAttribute, _super);
    /**
     * @param name - The attribute name
     * @param typeConstructor - The collection constructor of the attribute
     * @param elementType - The type of the elements of the attribute collection
     */
    function PluralAttribute(name, typeConstructor, elementType) {
        var _this = _super.call(this, name) || this;
        _this.elementType = elementType;
        _this.typeConstructor = typeConstructor;
        return _this;
    }
    Object.defineProperty(PluralAttribute.prototype, "persistentAttributeType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return Attribute_1.PersistentAttributeType.ELEMENT_COLLECTION;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Retrieves a serialized string value of the given json which can be used as object keys
     * @param json The json of which the key should be retrieved
     * @return A serialized version of the json
     */
    PluralAttribute.prototype.keyValue = function (json) {
        if (json && typeof json === 'object' && 'id' in json) {
            return String(json.id);
        }
        return String(json);
    };
    PluralAttribute.CollectionType = CollectionType;
    return PluralAttribute;
}(Attribute_1.Attribute));
exports.PluralAttribute = PluralAttribute;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGx1cmFsQXR0cmlidXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiUGx1cmFsQXR0cmlidXRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFFQSx5Q0FBaUU7QUFFakUsSUFBWSxjQUtYO0FBTEQsV0FBWSxjQUFjO0lBQ3hCLCtEQUFjLENBQUE7SUFDZCxtREFBUSxDQUFBO0lBQ1IsaURBQU8sQ0FBQTtJQUNQLGlEQUFPLENBQUE7QUFDVCxDQUFDLEVBTFcsY0FBYyxHQUFkLHNCQUFjLEtBQWQsc0JBQWMsUUFLekI7QUFFRDtJQUFvRCwyQ0FBWTtJQW1COUQ7Ozs7T0FJRztJQUNILHlCQUFzQixJQUFZLEVBQUUsZUFBeUIsRUFBRSxXQUFvQjtRQUFuRixZQUNFLGtCQUFNLElBQUksQ0FBQyxTQUdaO1FBRkMsS0FBSSxDQUFDLFdBQVcsR0FBRyxXQUFXLENBQUM7UUFDL0IsS0FBSSxDQUFDLGVBQWUsR0FBRyxlQUFlLENBQUM7O0lBQ3pDLENBQUM7SUFiRCxzQkFBSSxvREFBdUI7UUFIM0I7O1dBRUc7YUFDSDtZQUNFLE9BQU8sbUNBQXVCLENBQUMsa0JBQWtCLENBQUM7UUFDcEQsQ0FBQzs7O09BQUE7SUFhRDs7OztPQUlHO0lBQ08sa0NBQVEsR0FBbEIsVUFBbUIsSUFBVTtRQUMzQixJQUFJLElBQUksSUFBSSxPQUFPLElBQUksS0FBSyxRQUFRLElBQUksSUFBSSxJQUFJLElBQUksRUFBRTtZQUNwRCxPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7U0FDeEI7UUFFRCxPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN0QixDQUFDO0lBeENzQiw4QkFBYyxHQUFHLGNBQWMsQ0FBQztJQXlDekQsc0JBQUM7Q0FBQSxBQTFDRCxDQUFvRCxxQkFBUyxHQTBDNUQ7QUExQ3FCLDBDQUFlIn0=